/**
 * Directive Metro Search
 * @module Search Component
 */
define(function (require, exports) {
    'use strict';

    // @ngInject
    exports.metSearch = function (TEMPLATE_PATH) {
        return {
            restrict: 'E',
            require: ['^form'],
            replace: true,
            scope: {
                model: '=ngModel',
                btnText: '@',
                inputPlaceholder: '@',
                searchFn: '&',
                smallSearch: '=',
                errorMessage: '@',
                maxlength: '@',
                minlength: '@',
                required: '=',
                validCharacters: '@'
            },
            templateUrl: TEMPLATE_PATH + 'metSearch.html',
            link: function (scope, element, attrs, ctrls) {
                scope.form = ctrls[0];
                scope.errorObject = scope.form.search.$error;
                var searchInput = element.find('.form-control');

                /* when search icon inside input is clicked focus the input
                 for user to enter search params */
                scope.focusSearchInput = function () {
                    searchInput.focus();
                };

                scope.changeField = function (event) {
                    scope.searched = false;
                    if (event.keyCode === 13) {
                        scope.search();
                    }
                };

                // keypress validation for maxLength to prevent
                // user input more then max characters allowed
                scope.validateLength = function (event) {
                    // check event for backspace to prevent disabling backspace to delete value
                    // in input in firefox and ie. This validation is done only if maxLength property is defined
                    if (scope.maxlength !== undefined && event.target.value.length >= scope.maxlength && event.keyCode !== 8) {
                        event.preventDefault ? event.preventDefault() : event.returnValue = false;
                    }
                };

                scope.search = function () {

                    scope.searched = true;

                    if (scope.form.search.$valid) {
                        scope.searchFn();
                        searchInput.value = '';
                        scope.searched = false;
                    }

                };
            }
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/metSearch/metSearch.js